import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "filterWrapper" }
const _hoisted_2 = { class: "filterBtnWrapper" }
const _hoisted_3 = { key: 0 }

import { filter } from 'dom7';
import {
  onMounted, onUnmounted, ref,
} from 'vue';
import vClickOutside from '@venegrad/vue3-click-outside';
import { Icon } from '../../Atoms';
import FilterWindow from './FilterWindow.vue';
import { SMALL_DESKTOP_VIEWPORT_WIDTH } from '../../config';


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterMapButton',
  emits: ['toggleCheckedItems'],
  setup(__props, { emit: __emit }) {

const isFilterOpen = ref(!(window.innerWidth <= SMALL_DESKTOP_VIEWPORT_WIDTH));
const selectedItems = ref<Array<string>>(['destinations']);

const windowWidth = ref(window.innerWidth);

const emits = __emit;

const removeMobileOverlay = () => {
  document.querySelector('body')?.classList.remove('darkOverlay');
};

const addMobileOverlay = () => {
  document.querySelector('body')?.classList.add('darkOverlay');
};

const handleFilterBtnClick = () => {
  isFilterOpen.value = !isFilterOpen.value;

  // add overlay and stopscroll class to html and body tags for filter modal on mobile
  if (windowWidth.value <= SMALL_DESKTOP_VIEWPORT_WIDTH) {
    if (isFilterOpen.value) {
      addMobileOverlay();
    } else {
      removeMobileOverlay();
    }
  }
};

const setItemChecked = (e) => {
  emits('toggleCheckedItems', e.target.value, e.target.checked);
  if (!selectedItems.value.includes(e.target.value) && e.target.checked) {
    selectedItems.value.push(e.target.value);
  }
  if (!e.target.checked) {
    selectedItems.value = selectedItems.value.filter((x) => x !== e.target.value);
  }
};

const getCheckedIcon = (item: string) => {
  switch (item) {
    case 'destinations':
      return 'mapPinRed';
    case 'ports':
      return 'anchorRed';
    default:
      return 'routesRed';
  }
};

const handleCloseMobileFilter = () => {
  isFilterOpen.value = false;
  removeMobileOverlay();
};

onMounted(() => {
  window.addEventListener('resize', () => {
    windowWidth.value = window.innerWidth;
    if (windowWidth.value >= SMALL_DESKTOP_VIEWPORT_WIDTH) {
      removeMobileOverlay();
    }
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', () => {
    windowWidth.value = window.innerWidth;
  });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(["filterMapButton", {
          removeBottomRadius: isFilterOpen.value,
          removeRightRadius: selectedItems.value.length > 0 && !isFilterOpen.value
        }]),
          onClick: _withModifiers(handleFilterBtnClick, ["stop"])
        }, [
          _createVNode(_unref(Icon), {
            "icon-name": "filter",
            class: "filterIcon"
          }),
          _createTextVNode(" " + _toDisplayString(isFilterOpen.value ? _ctx.$t('Hide filters') : _ctx.$t('Show filters')), 1)
        ], 2),
        (!isFilterOpen.value && selectedItems.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["selectedPanel", {noText: selectedItems.value.length > 0}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItems.value, (item, index) => {
                return (_openBlock(), _createBlock(_unref(Icon), {
                  key: index,
                  "icon-name": getCheckedIcon(item)
                }, null, 8, ["icon-name"]))
              }), 128)),
              (selectedItems.value.length === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(selectedItems.value[0]), 1))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FilterWindow, {
        "is-filter-open": isFilterOpen.value,
        class: "desktopFilterWindow",
        onSetItemChecked: _cache[0] || (_cache[0] = (e) => setItemChecked(e))
      }, null, 8, ["is-filter-open"])
    ]),
    (_openBlock(), _createBlock(_Teleport, {
      to: "body",
      class: "mobile"
    }, [
      (windowWidth.value <= _unref(SMALL_DESKTOP_VIEWPORT_WIDTH))
        ? _withDirectives((_openBlock(), _createBlock(FilterWindow, {
            key: 0,
            "is-filter-open": isFilterOpen.value,
            "is-mobile": true,
            onSetItemChecked: _cache[1] || (_cache[1] = (e) => setItemChecked(e)),
            onCloseFilter: handleCloseMobileFilter
          }, null, 8, ["is-filter-open"])), [
            [_unref(vClickOutside), handleCloseMobileFilter]
          ])
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})